import * as React from 'react';
import type { FeaturedProduct } from '../../types/landing';

interface VerduProductsProps {
  products: FeaturedProduct[];
}

function getWholesaleFormat(product: FeaturedProduct) {
  return product.formats.find(f => f.is_wholesale) || product.default_format;
}

function formatPrice(price: number): string {
  return price.toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

export function VerduProducts({ products }: VerduProductsProps) {
  if (products.length === 0) return null;

  return (
    <section className="verdu-products">
      <style>{`
        .verdu-products {
          padding: 72px 24px;
          background: #fafaf7;
        }
        .verdu-products-inner {
          max-width: 960px;
          margin: 0 auto;
        }
        .verdu-products h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 8px;
          text-align: center;
        }
        .verdu-products .subtitle {
          font-size: 16px;
          color: #666;
          text-align: center;
          margin: 0 0 36px;
        }
        .verdu-products-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 20px;
        }
        .verdu-product-card {
          background: #fff;
          border-radius: 12px;
          border: 1px solid #eee;
          overflow: hidden;
          transition: box-shadow 0.2s;
        }
        .verdu-product-card:hover {
          box-shadow: 0 4px 16px rgba(0,0,0,0.08);
        }
        .verdu-product-img {
          width: 100%;
          height: 160px;
          object-fit: cover;
          display: block;
          background: #f5f5f5;
        }
        .verdu-product-body {
          padding: 14px 16px;
        }
        .verdu-product-cat {
          font-size: 12px;
          color: #1EAA25;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.3px;
          margin: 0 0 4px;
        }
        .verdu-product-name {
          font-size: 15px;
          font-weight: 600;
          color: #1a1a1a;
          margin: 0 0 6px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .verdu-product-format {
          font-size: 13px;
          color: #888;
          margin: 0 0 4px;
        }
        .verdu-product-price {
          font-size: 17px;
          font-weight: 700;
          color: #1EAA25;
          margin: 0 0 2px;
        }
        .verdu-product-lista {
          font-size: 11px;
          color: #aaa;
          font-weight: 500;
        }
        @media (max-width: 768px) {
          .verdu-products-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 12px;
          }
          .verdu-product-img {
            height: 120px;
          }
        }
        @media (max-width: 480px) {
          .verdu-products-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
      `}</style>
      <div className="verdu-products-inner">
        <h2>Frutas y verduras destacadas</h2>
        <p className="subtitle">Algunos de los productos que más piden nuestras verdulerías</p>
        <div className="verdu-products-grid">
          {products.map((product) => (
            <div key={product.id} className="verdu-product-card">
              <img
                className="verdu-product-img"
                src={product.webp_image_url || product.image_url}
                alt={product.title}
                loading="lazy"
              />
              <div className="verdu-product-body">
                <div className="verdu-product-cat">{product.category_name}</div>
                <div className="verdu-product-name">{product.title}</div>
                {(() => {
                  const fmt = getWholesaleFormat(product);
                  if (!fmt) return null;
                  return (
                    <>
                      <div className="verdu-product-format">
                        {fmt.short_name || fmt.name}
                      </div>
                      <div className="verdu-product-price">
                        ${formatPrice(fmt.price)}
                      </div>
                      <div className="verdu-product-lista">Precio de lista</div>
                    </>
                  );
                })()}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
